import { render, staticRenderFns } from "./editTermsPrice.vue?vue&type=template&id=0a9053e9&scoped=true"
import script from "./editTermsPrice.vue?vue&type=script&lang=js"
export * from "./editTermsPrice.vue?vue&type=script&lang=js"
import style0 from "./editTermsPrice.vue?vue&type=style&index=0&id=0a9053e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9053e9",
  null
  
)

export default component.exports